<template>
    <div class="container">
        <passport-clients></passport-clients>
        <passport-authorized-clients></passport-authorized-clients>
        <passport-personal-access-tokens></passport-personal-access-tokens>
    </div>
</template>

<script>
    let PassportClients = require('../../components/admin/passport/Clients.vue').default;
    let PassportAuthorizedClients = require('../../components/admin/passport/AuthorizedClients.vue').default;
    let PassportPersonalAccessTokens = require('../../components/admin/passport/PersonalAccessTokens.vue').default;
    
    export default {
        components: {
            PassportClients,
            PassportAuthorizedClients,
            PassportPersonalAccessTokens
        }    
    }
</script>